/**
 * CDN Configuration
 * Centralized configuration for Cloud CDN URLs
 * 
 * To use Cloud CDN, set REACT_APP_CDN_URL environment variable
 * Example: REACT_APP_CDN_URL=https://cdn.snageasy.in
 * 
 * If not set, falls back to direct GCS URLs
 */

// Get CDN base URL from environment variable or use default
const getCDNBaseUrl = () => {
  // Check environment variable first
  if (process.env.REACT_APP_CDN_URL) {
    return process.env.REACT_APP_CDN_URL.replace(/\/$/, ''); // Remove trailing slash
  }
  
  // Fallback to direct GCS URL
  return 'https://cdn.snageasy.in';
};

export const CDN_BASE_URL = getCDNBaseUrl();

// Helper function to get CDN URL for a given path
export const getCDNUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${CDN_BASE_URL}/${cleanPath}`;
};

// Predefined CDN paths
export const CDN_PATHS = {
  // Images
  IMAGES_BASE: 'app-img/webp',
  IMAGES_ASSETS: 'app-img/webp/assets',
  
  // Data
  BLOG_DATA: 'blog-data/blog-posts.json',
  PROJECTS_DATA: 'project-data/projects-data.json',
  
  // Specific images (commonly used)
  LOGO: 'app-img/webp/assets/logo.webp',
  AI_HERO: 'app-img/webp/assets/ai.webp',
  REPUBLIC_DAY_FLAG: 'app-img/webp/republic_day.webp',
};

// Export CDN URLs for common resources
export const CDN_URLS = {
  // Blog data
  BLOG_DATA: getCDNUrl(CDN_PATHS.BLOG_DATA),
  
  // Projects data
  PROJECTS_DATA: getCDNUrl(CDN_PATHS.PROJECTS_DATA),
  
  // Common images
  LOGO: getCDNUrl(CDN_PATHS.LOGO),
  AI_HERO: getCDNUrl(CDN_PATHS.AI_HERO),
  REPUBLIC_DAY_FLAG: getCDNUrl(CDN_PATHS.REPUBLIC_DAY_FLAG),
};

// Helper to get image URL
export const getImageUrl = (imagePath) => {
  // If already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If path starts with app-img, use CDN
  if (imagePath.startsWith('app-img/')) {
    return getCDNUrl(imagePath);
  }
  
  // Otherwise, assume it's a relative path from images base
  return getCDNUrl(`${CDN_PATHS.IMAGES_BASE}/${imagePath}`);
};
